export default __webpack_public_path__ + "static/logoLivereactingBlack-9c72d2862b21a9a452a694ece2e8d266.png";